// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"28345":"a9da290a2c30956b","58727":"d06520b04e8a74bd","65666":"c97aedd4cf3ed1f1"}[chunkId] + ".css";
};